import { AppEntities } from "src/config/entities";
import { DocumentService } from "./DocumentService";
import {IPurchaseOrderDto} from "src/components/Pages/Documents/Purchases/PurchaseOrders/dtos/IPurchaseOrderDto";

export class PurchaseOrdersService extends DocumentService {
  async Clone(id: string) {
    const newObject = await this.Get(id);
    const clonedObject = { ...newObject };
    console.log("clonedObject is", clonedObject);
    return clonedObject;
  }
  async createBasedAtOrder(id: string) {
    const orderDto = await AppEntities.VendorInvoices.getDataService().Get(id);
    const newCustomerInvoice: IPurchaseOrderDto = { ...orderDto };
    // newCustomerInvoice.paymentOffsets = [];
    return newCustomerInvoice;
  }
}
